export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q01_b.272d6b83.png";